import React from 'react'

const NoSearchResult = ({ searchTerm }) => {
    return (
        <div className='py-5 text-center'>'{searchTerm}' 에 대한 검색 결과가 없습니다.</div>
    )
}

export default NoSearchResult